export { default } from './es/icons/MoreFilled';